<!-- Единая стрелка раскрытия сводных карточек ПЛАНа и ФАКТа. -->
<template>
  <AppIcon
    class="plan-disclosure-icon"
    :class="{ 'plan-disclosure-icon--collapsed': !expanded }"
    name="chevronUp"
    :size="18"
    aria-hidden="true"
  />
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "OrderPlanCalculationDisclosureIcon",

  components: { AppIcon },

  props: {
    expanded: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.plan-disclosure-icon {
  display: block;
  flex: none;
}

.plan-disclosure-icon--collapsed {
  transform: rotate(180deg);
}
</style>
